import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type WorkOrderAssignmentPayoutRecord = NonNullable<
  ResultOf<
    typeof workOrderAssignmentPayoutRecordQuery
  >["workOrderAssignmentPayout"]
>;

export const workOrderAssignmentPayoutRecordQuery = graphql(`
  query WorkOrderAssignmentPayoutRecord($id: ID!) {
    workOrderAssignmentPayout(id: $id) {
      id
      status
      amount
      amount_tax
      currency
      transaction_reference
      paid_at
      workOrderAssignment {
        id
        proDriver {
          id
          name
          email
          phone
          bank_name
          bank_account_name
          bank_account_number
          bank_identifier_code
        }
        workOrder {
          id
          reference
          status
          depart_after
          deliver_before
        }
      }
      lineItems {
        id
        description
        tax_type
        amount_inc_tax
        amount_tax
        amount_exc_tax
      }
    }
  }
`);
